import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';

const BasicRadioTemplate = function(props) {
	const { t, field, value, label, onChange, disabled, className, name } = props;
	return (
		<div className="form__group__label" htmlFor={_.get(field, 'id')}>
			<input
				id={_.get(field, 'id')}
				onChange={onChange ? onChange : () => {}}
				value={value}
				name={name}
				checked={value}
				className={className}
				disabled={disabled}
				type="radio"
			/>
			<label htmlFor={_.get(field, 'id')}>{t(label)}</label>
		</div>
	);
};

BasicRadioTemplate.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.bool.isRequired,
	field: PropTypes.object.isRequired,
	name: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	t: PropTypes.any,
	onChange: PropTypes.func,
};

BasicRadioTemplate.defaultProps = {
	disabled: false,
};

export default defaultTemplate(BasicRadioTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/forms/BasicRadio.jsx